import BigPicture from "bigpicture";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

document.addEventListener("DOMContentLoaded", function (event) {

    var button = document.querySelector('[data-behaviour="menubutton"]');
    button.addEventListener("click", function (event) {
        document.body.classList.toggle("body--showmenu");
    })

    var toggles = document.querySelectorAll('[data-behaviour="section-toggle"]');
    toggles.forEach(toggle => {
        toggle.addEventListener("click", function (event) {
            toggle.parentNode.classList.toggle("section_text--open");
        })
    });

    var elements = [...document.querySelectorAll('[data-behaviour="lightbox"]')];

    elements.forEach(elem => {
        elem.addEventListener("click", e => {
            e.preventDefault();
            BigPicture({
                el: e.target,
                // ytSrc: 'z_PeaHVcohg',
                // imgSrc: elem.href,
                gallery: e.target.parentNode.parentNode.querySelectorAll("img")
            });
        });
    });

    if (document.querySelector('.swiper')) {
        new Swiper('.swiper', {
            modules: [Navigation, Pagination],
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });
    }

});
